import { createFileRoute, redirect } from "@tanstack/react-router";

/** Artwork is managed inside a campaign now (Manage Artwork), as in the Qwik platform. */
export const Route = createFileRoute("/artwork")({
  beforeLoad: () => {
    throw redirect({ to: "/account" });
  },
  component: () => null,
});
